import {
  Box,
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  InputLabel,
  RadioGroup,
  Radio,
  Typography
} from '@mui/material';
import './SingleChoicePreview.css';

const SingleChoicePreview = ({ question, templateType = {} }) => {
  const { options = [], config = {} } = question;
  const { value = '' } = templateType;
  const layout = config?.layout || 'vertical';

  return (
    <>
      <Box className='single-choice_preview'>
        {value === 'survey' ? (
          <FormControl>
            {layout === 'horizontal' ? (
              <RadioGroup
                sx={{
                  flexDirection: 'row',
                  gap: 3,
                  flexWrap: 'wrap'
                }}
              >
                {options.map((option) => (
                  <Box
                    key={option?.value}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 0.5,
                      minWidth: 'fit-content'
                    }}
                  >
                    <Typography
                      variant='body2'
                      sx={{
                        textAlign: 'center',
                        minHeight: '20px',
                        color: '#000000DE'
                      }}
                    >
                      {option?.option || ''}
                    </Typography>
                    <Radio
                      value={option?.value}
                      style={{ color: '#00000099' }}
                      sx={{ padding: '4px' }}
                    />
                  </Box>
                ))}
              </RadioGroup>
            ) : (
              <RadioGroup>
                {options.map((option) => (
                  <FormControlLabel
                    key={option?.value}
                    value={option?.value}
                    control={<Radio style={{ color: '#00000099' }} />}
                    label={option?.option || ''}
                  />
                ))}
              </RadioGroup>
            )}
          </FormControl>
        ) : (
          <Box sx={{ minWidth: 200 }}>
            <FormControl style={{ width: 220 }}>
              <InputLabel htmlFor='single-choice-options'>
                <span className='preview__input-label'>Answer</span>
              </InputLabel>
              <Select
                className='text-disabled select-disabled'
                defaultValue='none'
                inputProps={{
                  name: 'answer',
                  id: 'single-choice-options'
                }}
                disabled
                variant='standard'
              >
                <MenuItem value='none' disabled>
                  Select answer
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        )}
      </Box>
    </>
  );
};

export default SingleChoicePreview;